import { formatLocalDate } from "src/utils/common";

class ViewReservationSummaryModel {
    
    constructor(item) {
        this.Id = item?.Id ?? null;
        this.ReservationNumber = item?.ReservationNumber ?? null;
        this.ReservationReference = item?.ReservationReference ?? null;
        this.Status = item?.Status ?? null;
        this.CreatedDate = item?.CreatedDate ? formatLocalDate(item.CreatedDate) : null;
        this.PropertyName = item?.PropertyName ?? null;
        this.Name = item?.Metadata?.Name ?? null;
        this.NetSellTotal = Number(item?.Metadata?.ClientSell?.Total) || 0;
        this.Types = item?.Metadata?.Types ?? null;
        this.CheckIn = item?.CheckIn ? formatLocalDate(item.CheckIn) : null;
        this.CheckOut = item?.CheckOut ? formatLocalDate(item.CheckOut) : null;
        this.ClientSellTotal = item?.ClientSell?.Total || 0;
        this.ContractBuyTotal = item?.ContractBuy?.Total || 0;
        this.CreatedUserName = item?.CreatedUser?.DisplayName || "Unknown";
        this.AgentName = item?.Agent?.Name || "Unknown";
        this.SyncDetails = item?.SyncDetails ?? null;
        this.SyncStatus = item?.SyncStatus ?? null;
    }
}

export default ViewReservationSummaryModel;
